module.exports = __webpack_public_path__ + "images/78e7e41cf54df2fcc853494ea68c64fa.svg";